import "./footer.scss"

import React, { FC, useRef } from "react"
import Icon from "../../../images/youplanet-logo.svg";
import { t } from 'i18next';
import { getCurrentLanguage } from '../../../i18n';
import { YouplanetSections, getSectionSlug } from "../../../constants/general";

const Footer: FC = () => {
  const currentLanguage = getCurrentLanguage();
  const footer = useRef();

  const date = new Date().getFullYear().toString();
  const year = date.substring(2, 4);
  const yearNumber = date.substring(0, 1);

  return (
    <footer ref={footer} className="footer">
      <div className="footer__content">
        <p className="footer__item">{t('footer.copyright')} {yearNumber}K{year}</p>
        <p className="footer__item">
        <a href={getSectionSlug(YouplanetSections.DataProtection, currentLanguage)} className="footer__link">{t('footer.privacity')}</a> · <a href={getSectionSlug(YouplanetSections.NoticeOfConfidentiality, currentLanguage)} className="footer__link">{t('footer.conditions')}</a> · <a href={getSectionSlug(YouplanetSections.Legal, currentLanguage)} className="footer__link"> {t('footer.legalTerms')} </a>
        </p>
        <a href={`/${currentLanguage}`}>
          <img className="footer__item" src={Icon} alt="logo YouPlanet" />
        </a>
      </div>
    </footer>
  )
}
export default Footer
